/* Taking a red square off (Kevin, 2026-10-25).
 *
 * Right-click a red square on the board and this asks before it does anything:
 * why the square was charged — who the rotation went past them to, or that
 * somebody pressed Skip this turn — and what taking it off does, which is give
 * back the turn's credit it cost. That moves them up the queue, and the desk
 * should know it is doing that rather than tidying a colour.
 *
 * Escape and the scrim are "no": nothing has happened until the button is
 * pressed. The reasons and the removal are in js/rules/skip-marks.js.
 */
import { store } from '../store.js';

export const SkipRemove = {
  name: 'SkipRemove',
  setup: function () {
    return {
      d: store.skipRemoveDetail,
      confirm: store.confirmSkipRemove,
      close: store.closeSkipRemove
    };
  },
  template: [
    '<div v-if="d" class="modal-scrim" @click.self="close">',
    '  <div class="sheet" role="dialog" aria-modal="true" aria-labelledby="skip-remove-title">',
    '    <div class="sheet__head sheet__head--plain">',
    '      <div>',
    '        <h3 id="skip-remove-title">Take the red square off {{ d.name }}&rsquo;s turn {{ d.turn }}?</h3>',
    '        <p>A turn {{ d.name }} was passed over for</p>',
    '      </div>',
    '    </div>',
    '',
    '    <div class="assign__section">',
    '      <h4 class="assign__label">Why it was charged</h4>',
    '      <p class="warn-body">{{ d.story }}</p>',
    /* What the button does, in the floor's terms: the square is not decoration,
       it is a turn of credit, and giving it back moves them in the queue. */
    '      <p class="warn-body">Taking it off gives back the turn it cost them, so',
    '        {{ d.name }} moves up the queue as if they had not been passed over.',
    '        Nothing else on the board changes.</p>',
    '    </div>',
    '',
    '    <div class="sheet__actions">',
    '      <button type="button" class="btn btn--primary btn--lg" @click="confirm()">',
    '        Take it off</button>',
    '      <button type="button" class="btn btn--quiet" @click="close">Keep it</button>',
    '    </div>',
    '  </div>',
    '</div>'
  ].join('\n')
};
